import moment from "moment";
import { FORMAT } from "@/config/date-format";

const startDate = moment()
  .subtract(3, "months")
  .startOf("month")
  .format(FORMAT.DATE);
const endDate = moment()
  .startOf("month")
  .format(FORMAT.DATE);

export default {
  keywordsTableData: [],
  summary: null,
  topKeywords: null,
  keywords: [],
  keywordByDate: [],
  keywordsNextPage: null,
  keywordSearch: "",
  loadingMoreKeywords: false,
  loading: {
    list: false,
    summary: false,
    topKeywords: false,
    keywords: false,
    byDate: false
  },
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0
  },
  searchStats: {
    keywordsCount: 0,
    totalImpressions: 0
  },
  ordering: "-searches",
  filters: {
    gmb_address_ids: [],
    cities: [],
    facilities_groups_ids: [],
    date_from: startDate,
    date_to: endDate
  }
};
